import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import type { SeriesDetail } from "@/types/series";
import type { MediaFile, Person } from "@/types/movies";
import { deriveCountries, deriveGenres, deriveSubtitleLabel, deriveYear, findDirectorName, formatDuration, mapBackgroundImages, mapCast } from "../_shared/contentMeta";

// Note: series detail no longer embeds seasons/episodes (that moved to the
// dedicated GET /series/by-code/{code}/seasons endpoint — see
// useSeriesSeasons in queries/series.ts), so this hook only derives the
// series-level metadata fields that are still part of the detail response.
export function useSeriesDerived(seriesData) {
  const $ = _c(33);
  let t0;
  if ($[0] !== seriesData) {
    t0 = seriesData ?? {};
    $[0] = seriesData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const s = t0 as SeriesDetail;
  let t1;
  if ($[2] !== s.release_date) {
    t1 = deriveYear(s.release_date);
    $[2] = s.release_date;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const year = t1;
  let t2;
  if ($[4] !== s.tags) {
    t2 = deriveCountries(s.tags);
    $[4] = s.tags;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const countries = t2;
  let t3;
  if ($[6] !== s.tags) {
    t3 = deriveGenres(s.tags);
    $[6] = s.tags;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const genres = t3;
  const t4 = Boolean(s.subtitles?.length);
  const t5 = Boolean(s.dubs?.length);
  let t6;
  if ($[8] !== t4 || $[9] !== t5) {
    t6 = deriveSubtitleLabel(t4, t5);
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const subtitles = t6;
  let t7;
  if ($[11] !== s.medias) {
    t7 = s.medias ?? [];
    $[11] = s.medias;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = t7 as MediaFile[];
  let t9;
  if ($[13] !== t8) {
    t9 = mapBackgroundImages(t8);
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const images = t9;
  let t10;
  if ($[15] !== s.persons) {
    t10 = s.persons ?? [];
    $[15] = s.persons;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  const persons = t10 as Person[];
  let t11;
  if ($[17] !== persons) {
    t11 = mapCast(persons);
    $[17] = persons;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const cast = t11;
  let t12;
  if ($[19] !== persons) {
    t12 = findDirectorName(persons);
    $[19] = persons;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  const directorName = t12;
  const t13 = s.duration ?? "";
  let t14;
  if ($[21] !== t13) {
    t14 = formatDuration(t13);
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  const durationLabel = t14;
  let t15;
  if ($[23] !== cast || $[24] !== countries || $[25] !== directorName || $[26] !== durationLabel || $[27] !== genres || $[28] !== images || $[29] !== persons || $[30] !== subtitles || $[31] !== year) {
    t15 = {
      year,
      countries,
      genres,
      subtitles,
      images,
      persons,
      cast,
      directorName,
      durationLabel
    };
    $[23] = cast;
    $[24] = countries;
    $[25] = directorName;
    $[26] = durationLabel;
    $[27] = genres;
    $[28] = images;
    $[29] = persons;
    $[30] = subtitles;
    $[31] = year;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  return t15;
}